<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="decorative-icon">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/menu.svg?alt=media&token=6cc87810-c0f8-41a0-a994-8ca4aa3813cf"
          />
        </div>
        <div :class="isGenerating">
          <p
            class="mt-0 mb-3 text-md white bold"
          >Só um momento, gerando sua lista de compras da semana</p>
          <p class="mt-0 mb-0 text-sm white">
            <ion-icon mode="ios" name="flower" size="large" class="loading-icon"></ion-icon>
          </p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="top-title mt-0 mb-0 green text-xxl ion-text-uppercase">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
              />
              Lista de compras
            </p>
            <p
              class="mt-1 mb-0 white text-sm dark"
            >Para o período de {{ weekStart }} a {{ weekEnd }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="mt-4">
              <div v-if="shoppingList.data.list.length > 0">
                <div
                  v-for="item in shoppingList.data.list"
                  :key="item.namePT"
                  class="item-card mb-2"
                >
                  <ion-item lines="none">
                    <ion-label>
                      <p
                        class="mt-0 mb-0 pr-3 thin text-md darkgrey ion-text-wrap"
                      >{{ item.amount }} {{ item.unit }}</p>
                      <p class="mt-0 mb-0 pr-3 item-text bold dark ion-text-wrap">{{ item.namePT }}</p>
                    </ion-label>
                    <div
                      v-if="item.checked"
                      class="item-icon d-inline-block bg-green cursor-pointer"
                      @click="uncheckItem(item.namePT)"
                    >
                      <ion-icon name="checkmark" class="white"></ion-icon>
                    </div>
                    <div
                      v-else
                      class="item-icon d-inline-block bg-grey cursor-pointer"
                      @click="checkItem(item.namePT)"
                    >
                      <ion-icon name="checkmark" class="white"></ion-icon>
                    </div>
                  </ion-item>
                </div>
              </div>
              <div v-else>
                <p
                  class="mt-5 mb-5 pt-5 pb-5 darkgrey text-sm ion-text-center"
                >Sua lista de compras está vazia pra essa semana</p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <TabBar
      mealsClass="tab-grey"
      shoppingClass="white tab-green"
      profileClass="tab-grey"
      recipesClass="tab-grey"
    />
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// tab bar
import TabBar from "../../partials/structural/TabBar.vue";
// moment
import moment from "moment";
moment.locale("pt-br");
// rfdc
const clone = require("rfdc")();
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// services
import shoppingService from "@/services/shopping/shopping.js";
// component
export default {
  name: "ShoppingList",
  components: {
    TabBar,
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      isGenerating: "d-none",
      user: store.state.user,
      profile: store.state.profile,
      weekStart: null,
      weekEnd: null,
      shoppingList: {
        data: {
          list: []
        }
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    checkItem(name) {
      const instance = this;
      for (let i = 0; i < instance.shoppingList.data.list.length; i++) {
        if (instance.shoppingList.data.list[i].namePT === name) {
          instance.shoppingList.data.list[i].checked = true;
          const item = instance.shoppingList.data.list[i];
          instance.shoppingList.data.list.splice(i, 1);
          instance.shoppingList.data.list.splice(i, 0, item);
        }
      }
      db.collection("shoppingLists")
        .doc(instance.shoppingList.id)
        .update(instance.shoppingList.data);
    },
    uncheckItem(name) {
      const instance = this;
      for (let i = 0; i < instance.shoppingList.data.list.length; i++) {
        if (instance.shoppingList.data.list[i].namePT === name) {
          instance.shoppingList.data.list[i].checked = false;
          const item = instance.shoppingList.data.list[i];
          instance.shoppingList.data.list.splice(i, 1);
          instance.shoppingList.data.list.splice(i, 0, item);
        }
      }
      db.collection("shoppingLists")
        .doc(instance.shoppingList.id)
        .update(instance.shoppingList.data);
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      let shownList = [];
      // initialize dates
      const today = moment();
      const dayOfWeek = moment(today).isoWeekday();
      const fromDate = moment(today).startOf("week");
      const toDate = moment(today).endOf("week");
      let days = [];
      for (let i = 0; i < 7; i++) {
        const day = moment(fromDate)
          .add(i, "days")
          .format("DD/MM/YYYY");
        days.push(day);
      }
      const startDay = moment(fromDate).format("DD/MM/YYYY");
      instance.weekStart = moment(fromDate).format("DD/MM");
      instance.weekEnd = moment(toDate).format("DD/MM");
      const ref = db
        .collection("shoppingLists")
        .where("userId", "==", instance.user.uid)
        .where("startDay", "==", startDay);
      const snapshot = await ref.get();
      if (snapshot.empty) {
        instance.isLoading = false;
        instance.isGenerating = "generating-banner";
        // generate list
        const shoppingList = await shoppingService({ days: days });
        const obj = {
          userId: instance.user.uid,
          startDay: startDay,
          list: shoppingList
        };
        const docRef = await db.collection("shoppingLists").add(obj);
        shownList = {
          id: docRef.id,
          data: obj
        };
      } else {
        // use list
        snapshot.forEach(doc => {
          shownList = {
            id: doc.id,
            data: doc.data()
          };
        });
      }
      shownList.data.list.sort(function(a, b) {
        const textA = a.namePT.toUpperCase();
        const textB = b.namePT.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      instance.shoppingList = shownList;
      instance.isGenerating = "d-none";
      instance.isLoading = false;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}
ion-content {
  --background: transparent !important;
}
ion-item {
  --padding-start: 20px;
  --padding-end: 5px;
}
.item-text {
  font-size: 1.1rem !important;
  line-height: 1.3rem !important;
}
.item-card {
  background: white;
  box-shadow: 0 6px 3px -3px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.item-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
}
.item-icon ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.8rem;
}
.promotional-text {
  background: var(--ion-color-primary);
  color: white;
  margin-top: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 0 0 10px 10px;
}
</style>
